
import ADIBankAccountListReducer from '@NA/Store/Reducer/ADIBankAccountListReducer';
import ADIBillToReducer from '@NA/Store/Reducer/ADIBillToReducer';
import ADIBundledProductsReducer from '@NA/Store/Reducer/ADIBundledProductsReducer';
import ADICategoryRecommendedProductReducer from '@NA/Store/Reducer/ADICategoryRecommendedProductReducer';
import ADICheckoutCartReducer from '@NA/Store/Reducer/ADICheckoutCartReducer';
import ADICheckoutReviewAndSubmitReducer from '@NA/Store/Reducer/ADICheckoutReviewAndSubmitReducer';
import ADIChoiceGlobalProductsReducer from '@NA/Store/Reducer/ADIChoiceGlobalProductsReducer';
import ADICreditCardListRecapReducer from '@NA/Store/Reducer/ADICreditCardListRecapReducer';
import ADIGetBannerCarouselReducer from '@NA/Store/Reducer/ADIGetBannerCarouselReducer';
import ADIGetHomePageCarouselReducer from '@NA/Store/Reducer/ADIGetHomePageCarouselReducer';
import ADIGetProductAccessoriesReducer from '@NA/Store/Reducer/ADIGetProductAccessoriesReducer';
import ADIInventoryPuddlesReducer from '@NA/Store/Reducer/ADIInventoryPuddlesReducer';
import ADIInventoryReducer from '@NA/Store/Reducer/ADIInventoryReducer';
import ADIInventoryEDDReducer from '@NA/Store/Reducer/ADIInventoryEDDReducer';
import ADIInvoiceDetailsReducer from '@NA/Store/Reducer/ADIInvoiceDetailsReducer';
import ADIInvoicePaymentRecapReducer from '@NA/Store/Reducer/ADIInvoicePaymentRecapReducer';
import ADIInvoicesReducer from '@NA/Store/Reducer/ADIInvoicesReducer';
import ADIL1CategoryDataReducer from '@NA/Store/Reducer/ADIL1CatalogDataReducer';
import ADILoginDrawerReducer from '@NA/Store/Reducer/ADILoginDrawerReducer';
import ADIMobileFilterReducer from '@NA/Store/Reducer/ADIMobileFilterReducer';
import ADIMyBranchReducer from '@NA/Store/Reducer/ADIMyBranchReducer';
import ADIMyPurchaseHistoryConfigReducer from '@NA/Store/Reducer/ADIMyPurchaseHistoryConfigReducer';
import ADIMyPurchaseHistoryReducer from '@NA/Store/Reducer/ADIMyPurchaseHistoryReducer';
import ADIOrderDetailsReducer from '@NA/Store/Reducer/ADIOrderDetailsReducer';
import ADIOrdersListReducer from '@NA/Store/Reducer/ADIOrdersListReducer';
import ADIpdpUpdateTabReducer from '@NA/Store/Reducer/ADIpdpUpdateTabReducer';
import ADIQuoteDetailsReducer from '@NA/Store/Reducer/ADIQuoteDetailsReducer';
import ADIQuotesListReducer from '@NA/Store/Reducer/ADIQuotesListReducer';
import ADIRecentlyViewedReducer from '@NA/Store/Reducer/ADIRecentlyViewedReducer';
import ADIRecommendedProductsReducer from '@NA/Store/Reducer/ADIRecommendedProductsReducer';
import ADIRemovedItemReducer from '@NA/Store/Reducer/ADIRemovedItemReducer';
import ADIRewardsDrawerReducer from '@NA/Store/Reducer/ADIRewardsDrawerReducer';
import ADIUpdateCartLoadingReducer from '@NA/Store/Reducer/ADIUpdateCartLoadingReducer';
import ADIUserRoleReducer from '@NA/Store/Reducer/ADIUserRoleReducer';
import ADIVisualFilterReducer from '@NA/Store/Reducer/ADIVisualFilterReducer';
import GetShippingMethodReducer from '@NA/Store/Reducer/GetShippingMethodReducer';
import AIProtonReducer from '@NA/Widgets/AIProton/AIProtonReducer';
import LoyaltyRewardsReducer from '@NA/Widgets/LoyaltyRewards/LoyaltyRewardsReducer';
import ADISelectedOrdersListReducer from "@NA/Store/Reducer/ADISelectedOrdersListReducer";
import ADIRMASelectOrderReducer from "@NA/Store/Reducer/ADIRMASelectOrderReducer";
import ADIRMAConfirmReturnsReducer from "@NA/Store/Reducer/ADIRMAConfirmReturnsReducer";
import ADIClosePopoverReducer from '@NA/Store/Reducer/ADIClosePopoverReducer';
import ADIPromotionReducer from '@NA/Store/Reducer/ADIPromotionReducer';
import GetCartSummaryMethodReducer from '@NA/Store/Reducer/GetCartSummaryMethodReducer';
import ADIRMAStatusReducer from '@NA/Store/Reducer/ADIRMAStatusReducer';
import ADIRMAStatusDetailsReducer from '@NA/Store/Reducer/ADIRMAStatusDetailsReducer';
import ADIRequestPriceListReducer from '@NA/Store/Reducer/ADIRequestPriceListReducer';
import ADIOrderDetailsReturnItemsModal from "@NA/Components/OrderDetails/ADIOrderDetailsReturnItemsModal";
import ADIMyListsPaginationReducer from "@NA/Store/Reducer/ADIMyListsPaginationReducer";
import LoyaltyRewardsUserReducer from "@NA/Widgets/LoyaltyRewards/LoyaltyRewardsUserReducer";
import { combineReducers } from "redux";
import CoveoCommerceReducer from '@NA/Store/Reducer/CoveoCommerceReducer';
import ADIHomePageWishListDetailsReducer from "@NA/Store/Reducer/ADIHomePageWishListDetailsReducer";
import ADITrackOrderDrawerReducer from "@NA/Store/Reducer/ADITrackOrderDrawerReducer";
import PricingStatusReducer from "@NA/Widgets/NewCustomerPricingStatus/PricingStatusReducer";
import GetEddMethodReducer from '@NA/Store/Reducer/GetEddMethodReducer';

const customDataReducerData = {
    homePageCarouselStore: ADIGetHomePageCarouselReducer,
    bannerCarouselStore: ADIGetBannerCarouselReducer,
    loginDrawerStore: ADILoginDrawerReducer,
    removedItemStore: ADIRemovedItemReducer,
    checkoutErrorMessageStore: ADICheckoutReviewAndSubmitReducer,
    productAccessoriesStore: ADIGetProductAccessoriesReducer,
    wareHouseDataStore: ADIInventoryReducer,
    visualFilterStore: ADIVisualFilterReducer,
    ADIMobileFilterStore: ADIMobileFilterReducer,
    shippingMethodStore: GetShippingMethodReducer,
    myPurchaseHistoryStore: ADIMyPurchaseHistoryReducer,
    recentlyViewedStore: ADIRecentlyViewedReducer,
    ADIChoiceGlobalProductsStore: ADIChoiceGlobalProductsReducer,
    myPurchaseHistoryConfig: ADIMyPurchaseHistoryConfigReducer,
    bundledProductsStore: ADIBundledProductsReducer,
    ADIBillToStore: ADIBillToReducer,
    myBranchStore: ADIMyBranchReducer,
    quotesListStore: ADIQuotesListReducer,
    loyaltyRewardStore: LoyaltyRewardsReducer,
    AIProtonStore: AIProtonReducer,
    rewardsDrawerStore: ADIRewardsDrawerReducer,
    trackOrderDrawerStore: ADITrackOrderDrawerReducer,
    updatePDPTab: ADIpdpUpdateTabReducer,
    adiInvoiceDetails: ADIInvoiceDetailsReducer,
    adiInvoicePaymentRecap: ADIInvoicePaymentRecapReducer,
    ADIInvoiceStore: ADIInvoicesReducer,
    ADIRMAStatusStore: ADIRMAStatusReducer,
    adiBankAccountListStore: ADIBankAccountListReducer,
    adiCreditCardListRecapStore: ADICreditCardListRecapReducer,
    ordersListStore: ADIOrdersListReducer,
    quoteDetailsStore: ADIQuoteDetailsReducer,
    checkoutCartStore: ADICheckoutCartReducer,
    PdpInventoryPuddlesStore: ADIInventoryPuddlesReducer,
    // Below added property is a P21 Change
    ADIInventoryEDDStore:ADIInventoryEDDReducer,
    orderDetailsStore: ADIOrderDetailsReducer,
    PdpRecommendeProductsStore: ADIRecommendedProductsReducer,
    CategoryRecommendeProductsStore: ADICategoryRecommendedProductReducer,
    ADIUpdateCartLoading: ADIUpdateCartLoadingReducer,
    ADIUserRoleStore: ADIUserRoleReducer,
    l1CatLoadingStore: ADIL1CategoryDataReducer,
    ReturnHistoryDetails: ADIRMAStatusDetailsReducer,
    ADISelectedOrdersList: ADISelectedOrdersListReducer,
    ADIRMASelectOrderStore: ADIRMASelectOrderReducer,
    ClosePopOverStore: ADIClosePopoverReducer,
    loyaltyRewardUserStore: LoyaltyRewardsUserReducer,
    ADIPromotionStore: ADIPromotionReducer,
    ADIRMAConfirmReturns: ADIRMAConfirmReturnsReducer,
    requestPriceListStore: ADIRequestPriceListReducer,
    // Below added property is a P21 Change
    TaxSummaryStore: GetCartSummaryMethodReducer,
    adiMyListPaginationDataState: ADIMyListsPaginationReducer,
    coveoCommerce: CoveoCommerceReducer,
    HomePageWishListDetailsStore: ADIHomePageWishListDetailsReducer,
    PricingStatusStore: PricingStatusReducer,
    eddMethodStore: GetEddMethodReducer,
};

export type DataReducers = typeof customDataReducerData;

const customDataReducer = combineReducers(customDataReducerData as any);

export default customDataReducer;
